// extracted by mini-css-extract-plugin
export var active = "_2y-9";
export var backButton = "_2y-8";
export var clone = "_2y-e";
export var collapseBar = "_2y-k";
export var collapseMode = "_2y-m";
export var collapsed = "_2y-o";
export var dimmed = "_2y-i";
export var dragHandle = "_2y-c";
export var dropdownIcon = "_2y-g";
export var expanding = "_2y-n";
export var hidden = "_2y-x";
export var iconContainer = "_2y-q";
export var iconSwapper = "_2y-w";
export var navItem = "_2y-6";
export var navItemIcon = "_2y-f";
export var navProfile = "_2y-7";
export var notificationCountBadge = "_2y-j";
export var notificationDot = "_2y-r";
export var optionsContainer = "_2y-h";
export var primaryNav = "_2y-0";
export var primaryNavDivider = "_2y-v";
export var primaryNavResizeHandle = "_2y-2";
export var primaryNavResizing = "_2y-1";
export var primaryNavTabSection = "_2y-u";
export var primaryTab = "_2y-p";
export var primaryTabIconBox = "_2y-s";
export var secondaryNav = "_2y-3";
export var selected = "_2y-t";
export var settingsNav = "_2y-4";
export var settingsNavItems = "_2y-5";
export var show = "_2y-d";
export var sideNav = "_2y-l";
export var teamItem = "_2y-a";
export var userProfileItem = "_2y-b";